import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import Header from "../Layout/Header";
import SideBar from "../Layout/SideBar";
import axios from "axios";
import { baseURL } from "../../axios/common";
import Skeleton from "react-loading-skeleton"; // Import Skeleton

const ShowUser = () => {
  const { user_id } = useParams(); // Capture dynamic user_id from URL
  const { search } = useLocation(); // Capture the query parameters, including language
  const [userDetails, setUserDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Extract language from query string or default to 'en'
  const urlParams = new URLSearchParams(search);
  const language = urlParams.get('language') || 'en';

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      setError("No token found. Please log in.");
      setLoading(false);
      return;
    }

    if (!user_id) {
      setError("User ID is missing.");
      setLoading(false);
      return;
    }

    // Fetch user details from API using dynamic user_id and language
    axios
      .get(`${baseURL}admin/getUser/${user_id}?language=${language}`, {
        headers: {
          Authorization: `Bearer ${token}`,  // Ensure the token is passed in the request headers
        }
      })
      .then((response) => {
        setUserDetails(response.data.data);
        setLoading(false);
      })
      .catch((err) => {
        setError('Failed to fetch user details');
        setLoading(false);
      });
  }, [user_id, language]); // Re-fetch data when user_id or language changes

  if (loading) {
    return (
      <div>
        <Header />
        <SideBar />
        <main>
          <div className="content-wrapper pt-5 changePassword">
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="card">
                      <div className="card-header">
                        <h2>User Details</h2>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-4">
                            <Skeleton width="100%" height={20} />
                          </div>
                          <div className="col-md-4">
                            <Skeleton width="100%" height={20} />
                          </div>
                          <div className="col-md-4">
                            <Skeleton width="100%" height={20} />
                          </div>
                          <div className="col-md-4">
                            <Skeleton width="100%" height={20} />
                          </div>
                          <div className="col-md-4">
                            <Skeleton width="100%" height={20} />
                          </div>
                          <div className="col-md-4">
                            <Skeleton width={100} height={100} circle={true} />
                          </div>
                          <div className="col-md-4">
                            <Skeleton width="100%" height={20} />
                          </div>
                        </div>

                        <h4>Sports</h4>
                        <div className="row">
                          {Array.from({ length: 3 }).map((_, index) => (
                            <div className="col-md-4" key={index}>
                              <div className="card">
                                <div className="card-body text-center">
                                  <Skeleton circle width={60} height={60} />
                                  <Skeleton width="80%" height={20} style={{ marginTop: "10px" }} />
                                  <Skeleton width="60%" height={20} />
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>
      </div>
    );
  }

  const gender = (data) =>{
    if(data === 1) return 'Male'
    if(data === 2) return 'Female'
    if(data === 3) return "Other" 
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <>
      <Header />
      <SideBar />
      <main>
        <div className="content-wrapper pt-5 changePassword">
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-header">
                      <h2>User Details</h2>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4">
                          <label>Full Name</label>
                          <h6>{userDetails.name}</h6>
                        </div>
                        <div className="col-md-4">
                          <label>Email</label>
                          <h6>{userDetails.email}</h6>
                        </div>
                        <div className="col-md-4">
                          <label>Date of Birth</label>
                          <h6>{userDetails.date_of_birth}</h6>
                        </div>
                        <div className="col-md-4">
                          <label>Gender</label>
                          <h6>{gender(userDetails.gender)}</h6>
                        </div>
                        <div className="col-md-4">
                          <label>Bio</label>
                          <h6>{userDetails.bio}</h6>
                        </div>
                        <div className="col-md-4">
                          <label>Profile Picture</label>
                          <h6>
                            <img className='profile-img'
                              src={`${baseURL}${userDetails.profile_path}`}
                              alt="Profile"
                              style={{ width: '100px', height: '100px' }}
                            />
                          </h6>
                        </div>
                        <div className="col-md-4">
                          <label>Additional Images</label>
                          <div style={{ width: "100%" }} className='additional_div'>
                            {userDetails.additional_img_path.map((img, index) => (
                              <h6>
                                <img className='additional-img'
                                  key={index}
                                  src={`${baseURL}${img}`}
                                  alt={`Additional ${index + 1}`}
                                />
                              </h6>
                            ))}
                          </div>
                        </div>
                      </div>

                      <h4>Sports</h4>
                      <div className="row">
                        {userDetails.sports.map((sport, index) => (
                          <div className="col-md-4" key={index}>
                            <div className="card">
                              <div className="card-body text-center">
                                <div
                                  style={{
                                    backgroundColor: sport.color_code,
                                    borderRadius: "50%",
                                    width: "60px",
                                    height: "60px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    margin: "auto",
                                  }}
                                >
                                  <img
                                    src={baseURL + sport.icon_path}
                                    alt={sport.name}
                                    style={{ width: "60%", height: "60%" }}
                                  />
                                </div>

                                <h5 style={{ marginTop: "10px" }}>{sport.name}</h5>

                                <p>
                                  Skill Level:{" "}
                                  {sport.skill_level === 1
                                    ? " Beginner"
                                    : sport.skill_level === 2
                                    ? " Intermediate"
                                    : sport.skill_level === 3
                                    ? " Advanced"
                                    : "Unknown"}
                                </p>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </>
  );
};

export default ShowUser;
